import {
  FilterFieldDef,
  OPS_BOOLEAN,
  OPS_DATE_FULL,
  OPS_LIST,
  OPS_NUM_FULL,
  OPS_TEXT_CONTAINS,
  OPS_TEXT_FULL,
  OPS_TEXT_ID,
} from '../../../components/molecules/FilterBar';

export const STRUCTURE_FILTER_FIELD_DEFINITIONS: FilterFieldDef[] = [
  // ── Location ────────────────────────────────────────────────
  { name: 'Location ID', key: 'id', type: 'text', category: 'Location', operators: OPS_TEXT_ID },
  {
    name: 'Location Name',
    key: 'name',
    type: 'text',
    category: 'Location',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Location Type',
    key: 'nodeTypeName',
    type: 'list',
    category: 'Location',
    operators: OPS_LIST,
  },
  {
    name: 'Active',
    key: 'isActive',
    type: 'boolean',
    category: 'Location',
    operators: OPS_BOOLEAN,
  },
  { name: 'Notes', key: 'notes', type: 'text', category: 'Location', operators: OPS_TEXT_CONTAINS },
  {
    name: 'Tags',
    key: 'structureTags',
    type: 'text',
    category: 'Location',
    operators: OPS_TEXT_CONTAINS,
  },
  {
    name: 'Region Type',
    key: 'regionType',
    type: 'list',
    category: 'Location',
    operators: OPS_LIST,
  },
  { name: 'Zone', key: 'zone', type: 'text', category: 'Location', operators: OPS_TEXT_FULL },
  {
    name: 'Site Schema',
    key: 'siteSchema',
    type: 'text',
    category: 'Location',
    operators: OPS_TEXT_FULL,
  },

  // ── Hierarchy ───────────────────────────────────────────────
  {
    name: 'Parent Location ID',
    key: 'parentNodeId',
    type: 'text',
    category: 'Hierarchy',
    operators: OPS_TEXT_ID,
  },
  {
    name: 'Parent Location Name',
    key: 'parentName',
    type: 'text',
    category: 'Hierarchy',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Parent Location Type',
    key: 'parentNodeTypeName',
    type: 'list',
    category: 'Hierarchy',
    operators: OPS_LIST,
  },
  {
    name: 'Parent Active',
    key: 'parentActive',
    type: 'boolean',
    category: 'Hierarchy',
    operators: OPS_BOOLEAN,
  },
  {
    name: 'Client/Contract/Brand',
    key: 'clientContractBrand',
    type: 'text',
    category: 'Hierarchy',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Contract',
    key: 'contract',
    type: 'list',
    category: 'Hierarchy',
    operators: OPS_LIST,
  },
  { name: 'Client', key: 'client', type: 'text', category: 'Hierarchy', operators: OPS_TEXT_FULL },
  { name: 'Brand', key: 'brand', type: 'text', category: 'Hierarchy', operators: OPS_TEXT_FULL },
  {
    name: '# of Children (direct)',
    key: 'directChildCount',
    type: 'number',
    category: 'Hierarchy',
    operators: OPS_NUM_FULL,
  },
  {
    name: '# of Children (total)',
    key: 'totalChildCount',
    type: 'number',
    category: 'Hierarchy',
    operators: OPS_NUM_FULL,
  },

  // ── Address & Contact ───────────────────────────────────────
  {
    name: 'Main Address',
    key: 'mainAddress',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_CONTAINS,
  },
  // The split parts of `mainAddress`. These get OPS_TEXT_FULL rather than the
  // contains-only set `mainAddress` uses: `mainAddress` is a concatenated blob
  // where only "contains" is meaningful, whereas the whole point of the split
  // columns is exact matching — `Postcode contains 850` also matches 8500.
  {
    name: 'Main Address Line 1',
    key: 'mainAddressLine1',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Main Address Line 2',
    key: 'mainAddressLine2',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Main Address Suburb',
    key: 'mainAddressSuburb',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Main Address City',
    key: 'mainAddressCity',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Main Address Postcode',
    key: 'mainAddressPostcode',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Main Address State',
    key: 'mainAddressState',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Main Address Country',
    key: 'mainAddressCountry',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'All Addresses',
    key: 'allAddresses',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_CONTAINS,
  },
  {
    name: 'Main Contact',
    key: 'mainContact',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_CONTAINS,
  },
  {
    name: 'All Contacts',
    key: 'allContacts',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_CONTAINS,
  },
  {
    name: 'Trading Hours',
    key: 'tradingHrs',
    type: 'text',
    category: 'Address & Contact',
    operators: OPS_TEXT_CONTAINS,
  },

  // ── Reference Numbers ───────────────────────────────────────
  {
    name: 'Reference Number 1',
    key: 'referenceNo1',
    type: 'text',
    category: 'Reference Numbers',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Reference Number 2',
    key: 'referenceNo2',
    type: 'text',
    category: 'Reference Numbers',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Reference Number 3',
    key: 'referenceNo3',
    type: 'text',
    category: 'Reference Numbers',
    operators: OPS_TEXT_FULL,
  },

  // ── Presentation ────────────────────────────────────────────
  {
    name: 'Presentation',
    key: 'presentationValue',
    type: 'list',
    category: 'Presentation',
    operators: OPS_LIST,
  },
  {
    name: 'Presentation Date',
    key: 'presentationDate',
    type: 'date',
    category: 'Presentation',
    operators: OPS_DATE_FULL,
  },

  // ── Parts ───────────────────────────────────────────────────
  {
    name: 'Quantity Stock (Good)',
    key: 'goodPartCount',
    type: 'number',
    category: 'Parts',
    operators: OPS_NUM_FULL,
  },
  {
    name: 'Quantity Stock (Total)',
    key: 'partCount',
    type: 'number',
    category: 'Parts',
    operators: OPS_NUM_FULL,
  },

  // ── Misc ────────────────────────────────────────────────────
  {
    name: 'Created At',
    key: 'createdAt',
    type: 'date',
    category: 'Misc',
    operators: OPS_DATE_FULL,
  },
  {
    name: 'Created By',
    key: 'createdBy',
    type: 'text',
    category: 'Misc',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Updated At',
    key: 'updatedAt',
    type: 'date',
    category: 'Misc',
    operators: OPS_DATE_FULL,
  },
  {
    name: 'Updated By',
    key: 'updatedBy',
    type: 'text',
    category: 'Misc',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Import Session ID',
    key: 'importsessionId',
    type: 'text',
    category: 'Misc',
    operators: OPS_TEXT_FULL,
  },
];

export const STRUCTURE_FILTER_CATEGORIES = [
  'All',
  'Location',
  'Hierarchy',
  'Address & Contact',
  'Reference Numbers',
  'Presentation',
  'Parts',
  'Misc',
];
